import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { AppRoutes } from '../../routes/paths';
import { useAuthContext } from '../auth-provider';

// ----------------------------------------------------------------------

/**
 * A route guard that checks if the user is a resource manager.
 * This component should be used inside a route that is already protected by AuthOutlet,
 * as it assumes the user is already authenticated.
 *
 * If the user is a resource manager, it renders the child routes.
 * Otherwise, it redirects the user to the dashboard page.
 */
export const ResourceManagerRoute: React.FC = () => {
  const { isUserResourceManager } = useAuthContext();

  if (!isUserResourceManager) {
    return (
      <Navigate
        to={AppRoutes.ERROR_403}
        replace
      />
    );
  }

  return <Outlet />;
};
